<template>
  <v-container fluid>
    <!-- DESKTOP -->
    <div
      class="d-none d-lg-block ma-16 pa-16"
      v-html="$t('privacy')"
    ></div>

    <!-- MOBILE -->
    <div
      class="d-lg-none"
      v-html="$t('privacy')"
    ></div>
  </v-container>
</template>

<script setup>
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

const { locale } = useI18n({ useScope: 'global' })
const route = useRoute()

onMounted(() => {
  if (route.params.lang) {
    locale.value = route.params.lang
  }
})
</script>
